import React from 'react';
import { Routes, Route } from 'react-router-dom';

import { CustomerCreatePage } from './pages/CustomerCreatePage';
import { CustomerListPage } from './pages/CustomerListPage';
import { CustomerDetailPage } from './pages/CustomerDetailPage';

export const CustomerModule = () => (
  <Routes>
    <Route path={'/'} element={<CustomerListPage />} />
    <Route path={`/:id`} element={<CustomerDetailPage />} />
    <Route path={`/create`} element={<CustomerCreatePage />} />
  </Routes>
);
